import Select from "react-select";
import { MultiCompanySelector } from "../../../components/CompanySelector/index.jsx";
import {
  compactSelectStyles,
  multiCompanySelectStyles,
} from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";

const BuyerReportPanel = ({
  t,
  reportI18nKeys,
  eventsOptions,
  selectedEvent,
  selectedReportOption,
  loadingEvents,
  buyerCompaniesOptions,
  selectedBuyerCompanies,
  loadingBuyerCompanies,
  setSelectedBuyerCompanies,
  businessEventSelectProps,
  handlers,
}) => (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.EVENT)}</label>
      <Select
        options={eventsOptions}
        value={selectedEvent}
        onChange={handlers.onSelectEvent}
        isClearable
        isDisabled={!selectedReportOption}
        isLoading={loadingEvents}
        placeholder={t(reportI18nKeys.EVENT_PLACEHOLDER)}
        styles={compactSelectStyles}
        {...businessEventSelectProps}
      />
    </div>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.COMPANY)}</label>
      <MultiCompanySelector
        companies={buyerCompaniesOptions}
        selectedCompanies={selectedBuyerCompanies}
        loading={loadingBuyerCompanies}
        isDisabled={!selectedReportOption}
        placeholder={t(reportI18nKeys.COMPANY_PLACEHOLDER)}
        styles={multiCompanySelectStyles}
        onChange={setSelectedBuyerCompanies}
      />
    </div>
  </ReportFilterSection>
);

export default BuyerReportPanel;
